<template>
  <img
    v-if="logoUrl"
    :src="logoUrl"
    alt="MD CLUB"
    class="w-auto object-contain"
    :class="[imgHeight, white ? 'brightness-0 invert' : '']"
  />
</template>

<script setup lang="ts">
// `white` forces the logo white via CSS (it always sits on dark chrome), so it
// shows correctly no matter the uploaded asset color.
const props = withDefaults(defineProps<{ size?: 'sm' | 'md' | 'lg'; white?: boolean }>(), {
  size: 'md',
  white: true,
})

const { data: design } = useDesignSettings()

const logoUrl = computed(() => design.value?.logo || '')
const imgHeight = computed(() => ({ sm: 'h-6', md: 'h-9', lg: 'h-11' })[props.size])
</script>
